// Mirrors backend plans.evaluate_sheet: A1 refs (A = first column, 1 = first data row).
export const colLetter = (i) => { let s = ""; i += 1; while (i) { const r = (i - 1) % 26; s = String.fromCharCode(65 + r) + s; i = Math.floor((i - 1) / 26); } return s; };
const colIndex = (l) => [...l.toUpperCase()].reduce((n, ch) => n * 26 + (ch.charCodeAt(0) - 64), 0) - 1;
const num = (v) => { const n = parseFloat(String(v ?? "").replace(/,/g, "").trim()); return Number.isFinite(n) ? n : null; };

function safeArith(expr) {
  if (!/^[\d.+\-*/()\s]+$/.test(expr)) throw new Error("bad");
  let i = 0;
  const peek = () => expr[i];
  const ws = () => { while (expr[i] === " ") i++; };
  const factor = () => {
    ws();
    if (peek() === "(") { i++; const v = sum(); ws(); i++; return v; }
    if (peek() === "-") { i++; return -factor(); }
    if (peek() === "+") { i++; return factor(); }
    const m = /^\d*\.?\d+/.exec(expr.slice(i));
    if (!m) throw new Error("bad");
    i += m[0].length; return parseFloat(m[0]);
  };
  const term = () => { let v = factor(); for (;;) { ws(); if (peek() === "*") { i++; v *= factor(); } else if (peek() === "/") { i++; v /= factor(); } else return v; } };
  const sum = () => { let v = term(); for (;;) { ws(); if (peek() === "+") { i++; v += term(); } else if (peek() === "-") { i++; v -= term(); } else return v; } };
  const v = sum(); ws();
  if (i < expr.length || !Number.isFinite(v)) throw new Error("bad");
  return v;
}

const fmt = (v) => (Number.isInteger(v) ? String(v) : String(Math.round(v * 10000) / 10000));

export function evaluateSheet(columns, rows) {
  const raw = rows.map((r) => columns.map((c) => (r.c || {})[c.id] ?? ""));
  const cache = new Map();
  const cell = (ri, ci, depth = 0) => {
    if (ri < 0 || ci < 0 || ri >= raw.length || ci >= columns.length) return "";
    const k = `${ri}:${ci}`;
    if (cache.has(k)) return cache.get(k);
    const v = raw[ri][ci];
    const out = typeof v === "string" && v.startsWith("=") && depth < 50 ? formula(v.slice(1), depth) : v;
    cache.set(k, out);
    return out;
  };
  const ref = (s, depth) => { const m = /^([A-Z]+)(\d+)$/.exec(s); return cell(parseInt(m[2], 10) - 1, colIndex(m[1]), depth + 1); };
  const range = (a, b, depth) => {
    const m1 = /([A-Z]+)(\d+)/.exec(a), m2 = /([A-Z]+)(\d+)/.exec(b);
    const [c1, c2] = [colIndex(m1[1]), colIndex(m2[1])].sort((x, y) => x - y);
    const [r1, r2] = [parseInt(m1[2], 10) - 1, parseInt(m2[2], 10) - 1].sort((x, y) => x - y);
    const out = []; for (let r = r1; r <= r2; r++) for (let c = c1; c <= c2; c++) out.push(cell(r, c, depth + 1)); return out;
  };
  function formula(f, depth) {
    try {
      let s = f.toUpperCase();
      s = s.replace(/(SUM|AVERAGE|MIN|MAX|COUNT)\(([^()]*)\)/g, (_, name, args) => {
        const vals = [];
        args.split(",").map((p) => p.trim()).forEach((p) => {
          if (p.includes(":")) { const [a, b] = p.split(":"); vals.push(...range(a.trim(), b.trim(), depth)); }
          else if (/^[A-Z]+\d+$/.test(p)) vals.push(ref(p, depth));
          else if (p) vals.push(p);
        });
        const nums = vals.map(num).filter((x) => x !== null);
        if (name === "COUNT") return String(nums.length);
        if (!nums.length) return "0";
        const r = { SUM: nums.reduce((a, b) => a + b, 0), AVERAGE: nums.reduce((a, b) => a + b, 0) / nums.length, MIN: Math.min(...nums), MAX: Math.max(...nums) }[name];
        return String(r);
      });
      s = s.replace(/\b([A-Z]+)(\d+)\b/g, (m) => String(num(ref(m, depth)) ?? 0));
      s = s.replace(/×/g, "*").replace(/÷/g, "/").replace(/−/g, "-");
      return fmt(safeArith(s));
    } catch { return "#ERROR"; }
  }
  return raw.map((row, ri) => row.map((_, ci) => cell(ri, ci)));
}
